onLoad(($) => {
    const nodes = $('.JS-hide-type-offer');
  
    $(document).ready(function(){
      // Função para verificar e agir com base no texto dentro da span
      function checkSpanText(containerId, typeOfferId) {
          var spanText = $(containerId).text().trim();
          
          // Se o texto não for "DEB" ou "NC", desseleciona o input
          if (spanText !== "DEB" && spanText !== "NC") {
              $(typeOfferId).prop("checked", false);
          }
      }
      
      // Para título privado
      if ($("#select2-ticket_private_fixed_income_asset_type-container").length > 0) {
        checkSpanText("#select2-ticket_private_fixed_income_asset_type-container", "#ticket_private_fixed_income_type_offer_public");
        $('#select2-ticket_private_fixed_income_asset_type-container').on('DOMSubtreeModified', function() {
          checkSpanText("#select2-ticket_private_fixed_income_asset_type-container", "#ticket_private_fixed_income_type_offer_public");
        });
      }

      // Para dação - depósito
      if ($("#select2-ticket_dation_payment_asset_type_deposit-container").length > 0) {
        checkSpanText("#select2-ticket_dation_payment_asset_type_deposit-container", "#ticket_dation_payment_type_offer_deposit_public");
        $('#select2-ticket_dation_payment_asset_type_deposit-container').on('DOMSubtreeModified', function() {
          checkSpanText("#select2-ticket_dation_payment_asset_type_deposit-container", "#ticket_dation_payment_type_offer_deposit_public");
        });
      }

      // Para dação - retirada
      if ($("#select2-ticket_dation_payment_asset_type_withdrawal-container").length > 0) {
        checkSpanText("#select2-ticket_dation_payment_asset_type_withdrawal-container", "#ticket_dation_payment_type_offer_withdrawal_public");
        $('#select2-ticket_dation_payment_asset_type_withdrawal-container').on('DOMSubtreeModified', function() {
          checkSpanText("#select2-ticket_dation_payment_asset_type_withdrawal-container", "#ticket_dation_payment_type_offer_withdrawal_public");
        });
      }
  });
});